import { render, staticRenderFns } from "./purchase-horizon-statistics.vue?vue&type=template&id=f83128bc"
import script from "./purchase-horizon-statistics.vue?vue&type=script&lang=js"
export * from "./purchase-horizon-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports